import { recordClassIdentity } from './recordClassIdentity.js';

/** Historical class labels may help resolve legacy records, never override a real class ID. */
export function filterClassScope(items = [], classIds = new Set(), classes = [], matchField = 'classId') {
  return items.filter(item => {
    const id = item?.[matchField];
    if (id && classIds.has(id)) return true;
    if (matchField !== 'classId') return false;
    const identity = recordClassIdentity(item, classes);
    return Boolean(identity.classId && classIds.has(identity.classId));
  });
}
